import { Button, Popconfirm, Space, Tooltip } from "antd";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  PaperClipOutlined,
  SendOutlined,
} from "@ant-design/icons";

import { STATUS } from "../../type/status";
import { ROLES } from "../../type/roles";

const ListActionButton = ({
  deleteFunction,
  sendEmail,
  editFunction,
  showDetailFunction,
  signCustomer,
  dowloadContract,
  record,
  children,
}) => {
  return (
    <Space style={{}} size="small">
      {dowloadContract !== undefined ? (
        <Tooltip title="Tải hợp đồng">
          <Button
            onClick={dowloadContract}
            icon={<DownloadOutlined />}
            disabled={
              record && [STATUS.REJECTED].includes(record.status) ? true : false
            }
          />
        </Tooltip>
      ) : (
        <></>
      )}
      {editFunction !== undefined ? (
        <Tooltip title="Chỉnh sửa">
          <Button
            onClick={editFunction}
            icon={<EditOutlined />}
            disabled={
              record &&
              [
                STATUS.APPROVED,
                STATUS.DELETED,
                STATUS.COMPLETED,
                STATUS.STUDENT_SIGNED,
                STATUS.SEC_SIGNED,
              ].includes(record.status)
                ? true
                : false
            }
          />
        </Tooltip>
      ) : (
        <></>
      )}
      {showDetailFunction !== undefined ? (
        <Tooltip title="Xem chi tiết">
          <Button onClick={showDetailFunction} icon={<EyeOutlined />} />
        </Tooltip>
      ) : (
        <></>
      )}
      {signCustomer !== undefined ? (
        <Tooltip title="Gửi hợp đồng khách hàng ký">
          <Button
            onClick={signCustomer}
            icon={<PaperClipOutlined />}
            disabled={
              record && [STATUS.APPROVED].includes(record.status) ? false : true
            }
          />
        </Tooltip>
      ) : (
        <></>
      )}
      {sendEmail !== undefined ? (
        <Tooltip title="Gửi gmail">
          <Button
            onClick={sendEmail}
            icon={<SendOutlined />}
            // disabled={
            //   record &&
            //   [STATUS.APPROVED, STATUS.STUDENT_SIGNED].includes(record.status)
            //     ? false
            //     : true
            // }
          />
        </Tooltip>
      ) : (
        <></>
      )}
      {deleteFunction !== undefined ? (
        <Tooltip title="Xóa">
          <Popconfirm
            className="danger-confirm"
            title="Bạn muốn xóa?"
            onConfirm={deleteFunction}
            type="danger"
          >
            <Button
              icon={<DeleteOutlined />}
              danger
              disabled={
                localStorage.getItem("roles") !== ROLES.ROLE_ADMIN ||
                (record && record.status === STATUS.DELETED ? true : false)
              }
            />
          </Popconfirm>
        </Tooltip>
      ) : (
        <></>
      )}
      {children}
    </Space>
  );
};

export default ListActionButton;
